var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBagStylized = function SvgBagStylized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.67 13.56H9.5a2.25 2.25 0 0 0-2.25 2.25V51.95a2.25 2.25 0 0 0 2.25 2.25h37.17a2.25 2.25 0 0 0 2.25-2.25V15.81a2.25 2.25 0 0 0-2.25-2.25Z",
    fill: "#017C6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.755 21.746c0-.466.378-.843.844-.843h36.543c.466 0 .844.377.844.843V46.4a.844.844 0 0 1-.844.844H16.6a.844.844 0 0 1-.844-.844V21.746Zm1.687.844v22.965H52.3V22.59H17.442Z",
    fill: "#034638"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.582 7.688a4.406 4.406 0 0 0-4.422 4.406V26.41a.844.844 0 0 1-1.688 0V12.094A6.094 6.094 0 0 1 32.586 6h4.022a6.094 6.094 0 0 1 6.094 6.114V26.41a.844.844 0 0 1-1.687 0V12.11a4.408 4.408 0 0 0-4.407-4.421h-4.026Z",
    fill: "#034638"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.701 12.851c0-.466.378-.844.844-.844h32.651c.466 0 .844.378.844.844v8.895a.844.844 0 0 1-.844.844H18.545a.844.844 0 0 1-.844-.844v-8.895Zm1.688.844v7.207h30.963v-7.207H19.39Z",
    fill: "#034638"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.898 12.31a.844.844 0 0 1 1.19-.105l5.302 4.447a.844.844 0 0 1 0 1.293l-5.303 4.448a.844.844 0 1 1-1.084-1.293l4.531-3.801-4.531-3.801a.844.844 0 0 1-.105-1.189Zm33.945-.001c.3.357.253.889-.104 1.189l-4.53 3.8 4.53 3.802a.844.844 0 0 1-1.085 1.293l-5.299-4.448a.844.844 0 0 1 0-1.293l5.299-4.447a.844.844 0 0 1 1.188.104Z",
    fill: "#034638"
  })));
};
export default SvgBagStylized;